import {useNavigate, useParams} from 'react-router-dom';
import cardSpotImg from '../../../../assets/image/lendTech/cardSpotImg.jpg';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import ChatHeaderIcon from '../../../../components/mazraeKit/headers/ChatHeaderIcon/ChatHeaderIcon';
import CustomHeader from '../../../../components/mazraeKit/headers/homeHeader';
import NotificationHeaderIcon from '../../../../components/mazraeKit/headers/NotificationHeaderIcon/NotificationHeaderIcon';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useGetTakenLoanPaymentDetail from '../../../../services/hookService/getTakenLoanPaymentDetail/useGetTakenLoanPaymentDetail';
import {getPersianDateTimeV2} from '../../../../utilities/helper/GetPersianDateTime/index';
import StatsGrid from '../../cashBack/components/StatsGrid';

const NotPaidLoanDetailsPage = () => {
  const navigate = useNavigate();
  const {loanGuid} = useParams();

  const {data, isLoading} = useGetTakenLoanPaymentDetail(loanGuid);

  const isPayable = Boolean(data?.is_payable);

  const handleButtonAction = () => {
    if (isPayable)
      navigate('/installment-payment-gateway', {
        state: {loanGuid: loanGuid},
      });
    else navigate('/home');
  };

  const notPaidInstallments =
    data?.total_number_of_installments! - data?.number_of_paid_installments!;

  const usedCredit = data?.total_balance! - data?.remaining_balance!;

  const stats = [
    {
      title: 'کل اعتبار دریافت شده',
      value: data?.total_balance?.toLocaleString(),
      show: true,
      isPrice: true,
    },
    {
      title: 'اعتبار استفاده شده',
      value: usedCredit?.toLocaleString(),
      show: !isPayable,
      isPrice: true,
    },
    {
      title: 'هزینه خرید پلن تجاری',
      value: data?.plan_fee.toLocaleString(),
      show: isPayable,
      isPrice: true,
    },
    {
      title: 'کارمزد وام',
      value: data?.loan_fee?.toLocaleString(),
      show: isPayable,
      isPrice: true,
    },
    {
      title: 'مبلغ هر قسط',
      value: data?.amount_per_installment?.toLocaleString(),
      show: true,
      isPrice: true,
    },
    {
      title: 'اقساط پرداخت شده',
      value: data?.number_of_paid_installments?.toLocaleString(),
      show: isPayable,
    },
    {
      title: 'اقساط باقی مانده',
      value: notPaidInstallments.toLocaleString(),
      show: isPayable,
    },
  ];

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">اعتبار من</span>
          </div>
        )}
        postComponent={() => (
          <div className="flex gap-3 ">
            <NotificationHeaderIcon />
            <ChatHeaderIcon />
          </div>
        )}
      />

      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-[1.5rem] overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <section className="flex flex-col gap-[1.5rem]  text-sm rounded-[20px]">
              <div className="relative w-full overflow-hidden rounded-lg bg-[#F5FBEE] p-[1.5rem]">
                <img
                  src={cardSpotImg}
                  alt=""
                  className="absolute top-0 right-0 object-contain w-auto h-full"
                  style={{mixBlendMode: 'multiply'}}
                />

                <div className="flex flex-col gap-4">
                  <span className="text-sm font-medium text-right">
                    اعتبار باقی مانده
                  </span>
                  <span className="text-xl font-bold text-center">
                    {data?.remaining_balance?.toLocaleString() + ' تومان'}
                  </span>
                  <div className="flex justify-end gap-2 text-sm">
                    <span>انقضا</span>
                    <span>{getPersianDateTimeV2(data?.expire_date)}</span>
                  </div>
                </div>
              </div>

              <StatsGrid stats={stats} />

              {isPayable && (
                <div
                  className="flex items-center gap-2 pt-6 text-farm-shop-500 "
                  onClick={() =>
                    navigate(
                      `/loan-payment-details/${loanGuid}/isNotPaid?tab=isNotPaid`,
                    )
                  }
                >
                  <i className="text-xl icon-nameReceipt-bill" />
                  <span className="font-semibold text-md ">
                    جزئیات اقساط و پرداخت‌ها
                  </span>
                </div>
              )}

              <div className="fixed left-0 right-0 z-50 bottom-0 !bg-white shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]">
                <div className="flex w-full gap-16 p-3">
                  <div className="flex flex-col items-center justify-center gap-1 text-center">
                    <span className="text-gray-700 text-md">
                      مبلغ قابل پرداخت
                    </span>
                    <span className="font-medium text-md">
                      {data?.payment_price?.toLocaleString() + ' تومان'}
                    </span>
                  </div>
                  <Button
                    type="button"
                    className="w-full"
                    onClick={handleButtonAction}
                    disabled={!Boolean(data?.payment_price)}
                  >
                    {isPayable ? 'پرداخت' : 'خرید از فروشگاه'}
                  </Button>
                </div>

                <MainFooter isScrolling={false} />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default NotPaidLoanDetailsPage;
